import { FormField } from "@/types";

const questionaryInfoFields: (FormField & { fieldMeta?: Record<any, any> })[] = [
  {
    name: "about",
    label: "Bio",
    type: "textarea",
    fieldMeta: { allowedForMember: true, description: true },
  },
  {
    name: "website",
    label: "Website",
    fieldMeta: { allowedForMember: true, url: true, regExp: /^http(s)?:\/\/(?:www\.)?/, appendText: "http://" },
  },
  {
    name: "facebook",
    label: "Facebook",
    appendIcon: "sci-facebook-dark",
    fieldMeta: {
      social: true,
      site: "https://facebook.com/",
      regExp: /(?:(?:https?:\/\/)?.*facebook\.com\/)?([^/?]+)/,
    },
  },
  {
    name: "twitter",
    label: "Twitter",
    appendIcon: "sci-twitter-dark",
    fieldMeta: { social: true, site: "https://twitter.com/", regExp: /(?:(?:https?:\/\/)?.*twitter\.com\/)?([^/?]+)/ },
  },
  {
    name: "instagram",
    label: "Instagram",
    appendIcon: "sci-instagram-dark",
    fieldMeta: {
      social: true,
      site: "https://instagram.com/",
      regExp: /(?:(?:https?:\/\/)?.*instagram\.com\/|@?)?([^/?]+)/,
    },
  },
  {
    name: "tiktok",
    label: "TikTok",
    appendIcon: "sci-tik-tok-dark",
    fieldMeta: {
      social: true,
      site: "https://tiktok.com/@",
      regExp: /(?:(?:https?:\/\/)?.*tiktok\.com\/@)?([^/?]+)/,
    },
  },
  {
    name: "youtube",
    label: "YouTube",
    appendIcon: "sci-youtube-dark",
    fieldMeta: {
      social: true,
      site: "https://youtube.com/",
      regExp: /(?:(?:https?:\/\/)?.*youtube\.com\/)?([^*]+)/,
    },
  },
  {
    name: "snapchat",
    label: "Snapchat",
    appendIcon: "sci-snapchat-dark",
    fieldMeta: {
      social: true,
      site: "https://snapchat.com/add/",
      regExp: /(?:(?:https?:\/\/)?.*snapchat\.com\/add\/)?([^/?]+)/,
    },
  },
  {
    name: "patreon",
    label: "Patreon",
    appendIcon: "sci-patreon-dark",
    fieldMeta: {
      social: true,
      site: "https://patreon.com/",
      regExp: /(?:(?:https?:\/\/)?.*patreon\.com\/)?([^/?]+)/,
    },
  },
  {
    name: "onlyfans",
    label: "OnlyFans",
    appendIcon: "sci-only-fans-dark",
    fieldMeta: {
      social: true,
      site: "https://onlyfans.com/",
      regExp: /(?:(?:https?:\/\/)?.*onlyfans\.com\/|@?)?([^/?]+)/,
    },
  },
  {
    name: "linkedin",
    label: "LinkedIn",
    appendIcon: "sci-linkedin-dark",
    fieldMeta: {
      social: true,
      site: "https://linkedin.com/in/",
      regExp: /(?:(?:https?:\/\/)?.*linkedin\.com\/in\/)?([^/?]+)/,
    },
  },
  {
    name: "amazonWishlist",
    label: "Wish List URL",
    appendIcon: "sci-amazon-dark",
    fieldMeta: {
      amazon: true,
      url: true,
      regExp: /^http(s)?:\/\/(?:www\.)?/,
      appendText: "http://",
      logo: "sci-amazon-logo-dark",
    },
  },
  {
    name: "calendar",
    label: "Calendar",
    appendIcon: "sci-calendar-dark",
    fieldMeta: {
      calendar: true,
      url: true,
      regExp: /^http(s)?:\/\/(?:www\.)?/,
      appendText: "http://",
      logo: "sci-calendar-dark",
    },
  },
];

export default questionaryInfoFields;
